import './App.css';
import { useEffect, useState } from 'react';
import Nav from './components/header/Nav';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/pages/Login';
import Footer from './components/footer/Footer';
import ForgetPassword from './components/pages/ForgetPassword';
import Verify_OTP from './components/pages/Verify_OTP';
import ChangePassword from './components/pages/ChangePassword';
import Home from './components/pages/home/Home';
import PrivateComponent from './components/PrivateComponent';
import Welcome from './components/pages/Welcome'

import BuyPlan from './components/pages/BuyPage';
// import BusinessList2 from './components/content/BusinessList2';
import BusinessList from './components/content/BusinessList';
import CountryListing from './components/content/Country/CountryListing';
import StateList from './components/content/State/StateList';
import DistrictList from './components/content/District/DistrictList';
import GroupList from './components/content/Group/GroupList';
import SideNavBar from './components/sideNavBar/SideNavBar';
import GroupCustomerDataList from './components/content/GroupCustomerData/GroupCustomerDataList';
import CustomerDataList from './components/content/Customer Data/CustomerDataList';
// import PlanList from './components/content/plan/Plan_List';
import AddPlanService from './components/content/managePlanService/AddService';
import AddPackage from './components/content/managePlanService/AddPackage';
import AddFeature from './components/content/managePlanService/AddFeature';
import AddPlan from './components/content/plan/AddPlan';
import FeatureList from './components/content/managePlanService/FeatureList';
import ServiceList from './components/content/managePlanService/ServiceList';
import PackageList from './components/content/managePlanService/PackageList';
import UtilizeMessages from './components/content/messages/UtilizeMessages';
import LetestRchargeStatus from './components/content/letest_recharge_status/LetestRchargeStatus';
import IssueList from './components/content/issueList/IssueList';
import IssueCommunication from './components/content/issueList/IssueCommunication';
import CreateContactsCost from './components/content/buy_contacts_plan/CreateContactsCost';
import ContactsCostList from './components/content/buy_contacts_plan/ContactsCostList';
import AddNewRegistration from './components/content/AddNewRegistration/AddNewRegistration';
import ExpirePlanList from './components/content/expirePlan/expirePlan';
import Preference from './components/content/setting/Preference';
import CreateWhatsappCredential from './components/content/ManageWhatsappCredential/CreateWhatsappCredential';
import BuyContactsRequest from './components/content/buyRequest/BuyContactsRequest';
import BuyPlanRequest from './components/content/buyRequest/BuyPlanRequest';
import InsertContactsPayment from './components/content/payment/InsertContactsPayment';
import InsertPlansPayment from './components/content/payment/InsertPlansPayment';
import CreateJob from "./components/pages/CreateJob";
import JobList from "./components/pages/JobList";
import AddCourse from "./components/pages/AddCourse";
import CourseList from "./components/pages/CourseList";
import JobApplications from "./components/pages/JobApplications";
import PartnerList from "./components/pages/PartnerList";
import Projects from "./components/pages/Projects";
import InterviewSchedule from "./components/pages/InterviewSchedule";
import RequestTraining from "./components/pages/RequestTraining";
import RoleManagement from './components/pages/RoleManagement';
import UserRoleManagement from "./components/pages/UserRoleManagement";
import RolePermissionManagement from "./components/pages/RolePermissionManagement";
import HrActions from "./components/pages/HrActions";
import HrList from "./components/pages/HrList";
import HrDetail from "./components/pages/HrDetail";
import CreateHr from "./components/pages/CreateHr";
import CreateEmployee from "./components/pages/CreateEmployee";
import NewDashboard from "./components/pages/home/NewDashboard";
import { NotificationProvider } from "./context/NotificationContext";


function App() {
  const [showFooter, setFooter] = useState(true);
  const auth = localStorage.getItem('token');
  return (
    <BrowserRouter>
      <NotificationProvider>
        <div className="app-layout">
      
        <Nav setFooter={setFooter} />
        {auth ? <SideNavBar /> : null}
        <div>

        <Routes>
          <Route element={<PrivateComponent />}>
            <Route path="/" element={<NewDashboard />} />

            <Route path="/old-dashboard" element={<Home />} />

            <Route path="/new-dashboard" element={<NewDashboard />} />
            <Route path="/buyplan" element={<BuyPlan />} />
            {/* <Route path="/BusinessList2" element={<BusinessList2/>} /> */}
            <Route path="/BusinessList" element={<BusinessList />} />
            <Route path="/CountryListing" element={<CountryListing />} />
            <Route path='/StateList' element={<StateList />} />
            <Route path='/DistrictList' element={<DistrictList />} />
            <Route path='/GroupList' element={<GroupList />} />
            <Route path='/GroupCustomerDataList' element={<GroupCustomerDataList />} />
            <Route path='/CustomerDataList' element={<CustomerDataList />} />
            <Route path='/UtilizeMessages' element={<UtilizeMessages />} />
            <Route path='/LetestRchargeStatus' element={<LetestRchargeStatus />} />
            {/* <Route path="/planList" element={<PlanList/>} /> */}
            <Route path='/IssueList' element={<IssueList />} />

            <Route path='/IssueCommunication' element={<IssueCommunication />} />

            <Route path="/addservice" element={<AddPlanService />} />
            <Route path="/addpackage" element={<AddPackage />} />
            <Route path="/addfeature" element={<AddFeature />} />
            <Route path="/addplan" element={<AddPlan />} />
            <Route path="/featureList" element={<FeatureList />} />
            <Route path="/service-list" element={<ServiceList />} />
            <Route path="/package-list" element={<PackageList />} />
            <Route path="/create-contact-plan" element={<CreateContactsCost />} />
            <Route path="/contact-plan" element={<ContactsCostList />} />
            <Route path="/addNewBusiness" element={<AddNewRegistration />} />
            <Route path="/expirePlan" element={<ExpirePlanList />} />
            <Route path="/insert-whatsapp-credential" element={<CreateWhatsappCredential />} />
            <Route path="/logout" element={<h1>Logout</h1>} />
            <Route path="/preference" element={<Preference />} />
            <Route path="/buy-contacts-request" element={<BuyContactsRequest />} />
            <Route path="/buy-plan-request" element={<BuyPlanRequest/>} />
            <Route path="/insert-contacts-payment" element={<InsertContactsPayment/>}/>
            <Route path="/insert-plans-payment" element={<InsertPlansPayment/>}/>
            <Route path="/create-job" element={<CreateJob />} />
            <Route path="/job-list" element={<JobList />} />
            <Route path="/add-courses" element={<AddCourse />} />
            <Route path="/course-list" element={<CourseList />} />  
            <Route path="/job-application" element={<JobApplications />} />
            <Route path="/partner-list" element={<PartnerList />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/interview-schedule" element={<InterviewSchedule />} /> 
            <Route path="/request-training" element={<RequestTraining />} />
            <Route path="/role-management" element={<RoleManagement />} /> 
            <Route path="/user-role-management/:roleId" element={<UserRoleManagement />}/>
            <Route path="/role-permission-management" element={<RolePermissionManagement />}/>
            <Route path="/hr-actions" element={<HrActions />} />
            <Route path="/hr-list" element={<HrList />} />
            <Route path="/hr-list/:hrId" element={<HrDetail />} />
            <Route path="/create-hr" element={<CreateHr />} />
            <Route path="/create-employee" element={<CreateEmployee />} />
            
            
       
        

          
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          {/* <Route path="/verify_otp" element={<Verify_OTP />} /> */}
          <Route path="/changePassword" element={<ChangePassword />} />
          

        </Routes>
        </div>
      
      {/* FOOTER (FINAL FIX) */}
        {showFooter && (
          <div style={{ width: "100%" }}>
            <Footer />
          </div>
        )}

      </div>
      </NotificationProvider>
    </BrowserRouter>
  );
      
}

export default App;